import React, { Component } from 'react';
import { Table, Glyphicon } from 'react-bootstrap';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { getEquipmentTypesForShipmentTypes } from 'constants/EquipmentTypes';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import { formattedLastSeen, formatPlatformLabel, } from 'utils/localization/utils';
import { formatDate } from 'utils/formatters/Date';
import UserActionCreators from '../../../actions/UserActionCreators';
import AddDriverFormActionCreators from '../../../actions/drivers/AddDriverFormActionCreators';
import DriverActionsCreators from '../../../actions/DriverActionCreators';
import AddDriverFormStore from '../../../stores/drivers/AddDriverFormStore';
import SessionStore from '../../../stores/SessionStore';
import DriverStore from '../../../stores/DriverStore';
import DriverJobsModal from './DriverJobsModal';
import AddDriverModal from '../user/carrier/add-driver-modal';
import { Avatar } from '../user/Avatar';
import SHIPMENT_TYPES from 'constants/ShipmentTypes';
const shipmentTypes = SHIPMENT_TYPES.map((type) => type.value);
function getHandleAuthorizedChange(id) {
    return (e) => {
        const authorized = e.target.checked ? 1 : 0;
        DriverActionsCreators.toggleDriverAuthorization(id, authorized);
    };
}
function getHandleMultiplePickupsChange(id) {
    return (e) => {
        const multiplePickupAllowed = e.target.checked;
        DriverActionsCreators.toggleMultiplePickup(id, multiplePickupAllowed);
    };
}
function getHandleReceiveOffersChange(id) {
    return (e) => {
        const receiveOffers = e.target.checked;
        DriverActionsCreators.toggleReceiveOffers(id, receiveOffers);
    };
}
function fetchDrivers() {
    const carrier = SessionStore.getUser();
    if (carrier) {
        DriverActionsCreators.getAllDriversForCarrier(carrier._id);
    }
}
class DriverList extends Component {
    constructor(props) {
        super(props);
        this.handleAddDriverFormChange = () => {
            const formState = AddDriverFormStore.getFormState();
            this.setState({
                addDriverModal: {
                    formState,
                },
                savingDriver: false,
            });
            if (formState.isSuccess) {
                fetchDrivers();
                setTimeout(() => {
                    AddDriverFormActionCreators.hideForm();
                }, 3000);
            }
            else if (formState.submittable) {
                const carrier = SessionStore.getUser();
                if (carrier) {
                    UserActionCreators.addDriver(Object.assign(Object.assign({}, formState.driver), { carrier: carrier._id }));
                }
            }
        };
        this.handleCloseAddDriverModal = () => {
            AddDriverFormActionCreators.hideForm();
        };
        this.handleShowAddDriverModal = () => {
            AddDriverFormActionCreators.showForm();
        };
        this.handleCloseModal = () => {
            AddDriverFormActionCreators.hideForm();
            this.setState({
                jobModal: {
                    isOpen: false,
                    jobs: [],
                    type: '',
                    name: '',
                },
            });
        };
        this.handleAddDriver = (driver) => {
            this.setState({ savingDriver: true }, () => AddDriverFormActionCreators.requestValidateNewDriver(driver));
        };
        this.handleDriverChange = () => {
            const drivers = DriverStore.getAllDrivers();
            this.setState({
                drivers,
                loading: false,
            });
        };
        this.handleEquipmentTypeSave = async (e, driverId) => {
            const label = e.target.value === 'Select' ? '' : e.target.value;
            try {
                const update = { equipment_class: { label } };
                const response = await UserWebAPIUtils.updateDriverEquipment(driverId, update);
                if (response.success) {
                    fetchDrivers();
                }
            }
            catch (e) {
                console.log('Equipment save error: ', e);
            }
        };
        this.renderEquipmentTypes = (driver) => {
            const equipmentClass = driver.equipment_class;
            const equipment = equipmentClass ? equipmentClass.label : null;
            const { t } = this.props;
            return (React.createElement("div", null,
                React.createElement("select", { className: "w-56 form-select", caption: t('SELECT_A_VEHICLE'), value: equipment, onSelect: (e) => this.handleEquipmentTypeSave(e, driver._id), onChange: (e) => this.handleEquipmentTypeSave(e, driver._id) },
                    React.createElement("option", { key: "select", value: "select" }, t('SELECT')),
                    getEquipmentTypesForShipmentTypes(shipmentTypes).map((item) => (React.createElement("option", { key: item.label, value: item.label }, t(item.label)))))));
        };
        this.state = {
            drivers: [],
            loading: true,
            jobModal: {
                isOpen: false,
                jobs: [],
                type: '',
            },
            addDriverModal: {
                formState: {
                    error: {},
                    show: false,
                    isSuccess: false,
                },
            },
            savingDriver: false,
        };
    }
    componentDidMount() {
        fetchDrivers();
        DriverStore.addChangeListener(this.handleDriverChange);
        AddDriverFormStore.addChangeListener(this.handleAddDriverFormChange);
    }
    componentWillUnmount() {
        DriverStore.removeChangeListener(this.handleDriverChange);
        AddDriverFormStore.removeChangeListener(this.handleAddDriverFormChange);
    }
    renderDrivers() {
        const { drivers, loading } = this.state;
        const { t } = this.props;
        if (loading) {
            return (React.createElement("tr", null,
                React.createElement("td", { colSpan: "4" }, t('LOADING'))));
        }
        if (!drivers || drivers.length === 0) {
            return (React.createElement("tr", null,
                React.createElement("td", { colSpan: "4" }, t('NO_DRIVER_REGISTERED'))));
        }
        return drivers.map((driver) => {
            const glyph = driver.available ? 'ok-circle' : 'ban-circle';
            const glyphClassName = classnames({
                'text-green': glyph === 'ok-circle',
                'text-red': glyph === 'ban-circle',
            });
            const driverLink = `/drivers/${driver._id}/manage`;
            const createdAt = (driver === null || driver === void 0 ? void 0 : driver.created_at)
                ? formatDate(driver === null || driver === void 0 ? void 0 : driver.created_at, {
                    dateFormat: DEFAULT_DATE_FORMAT,
                    timeFormat: DEFAULT_TIME_FORMAT,
                    timezone: DEFAULT_TIMEZONE,
                    showTimezone: false,
                    t,
                })
                : '';
            return (React.createElement("tr", { key: driver._id },
                React.createElement("td", null,
                    React.createElement(Avatar, { key: driver._id, userId: driver._id, altName: driver.fullName, className: "inline-block w-8 h-8 mr-2 rounded-full" }),
                    React.createElement("div", { className: "caption" },
                        React.createElement("a", { href: driverLink }, driver.fullName))),
                React.createElement("td", null,
                    React.createElement("span", null, driver.username)),
                React.createElement("td", null,
                    React.createElement("span", null, createdAt)),
                React.createElement("td", null,
                    React.createElement("span", null, formattedLastSeen(driver.lastSeen))),
                React.createElement("td", null,
                    React.createElement("span", null, formatPlatformLabel(driver.platformLabel.toString()))),
                React.createElement("td", null,
                    React.createElement("span", null, this.renderEquipmentTypes(driver))),
                React.createElement("td", null,
                    React.createElement(Glyphicon, { glyph: glyph, className: glyphClassName })),
                React.createElement("td", null,
                    React.createElement("input", { type: "checkbox", checked: driver.authorized, onChange: getHandleAuthorizedChange(driver._id) })),
                React.createElement("td", null,
                    React.createElement("input", { type: "checkbox", checked: driver.can_accept_offers_before_pickup, onChange: getHandleMultiplePickupsChange(driver._id) })),
                React.createElement("td", null,
                    React.createElement("input", { type: "checkbox", checked: driver.receive_offers, onChange: getHandleReceiveOffersChange(driver._id) }))));
        });
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: "container driver-list" },
            React.createElement("div", { className: "driver-list-actions" },
                React.createElement("button", { className: "button button-green", onClick: this.handleShowAddDriverModal },
                    React.createElement(Glyphicon, { glyph: "plus" }),
                    t('ADD_DRIVER'))),
            React.createElement(Table, { striped: true, hover: true, className: "driver-list-table" },
                React.createElement("thead", null,
                    React.createElement("tr", { className: "text-grey-darkest" },
                        React.createElement("th", null, titleize(t('DRIVER', { count: 1 }))),
                        React.createElement("th", null, titleize(t('USERNAME', { count: 1 }))),
                        React.createElement("th", null, t('CREATED_DATE')),
                        React.createElement("th", null, t('LAST_SEEN')),
                        React.createElement("th", null, titleize(t('PLATFORM', { count: 1 }))),
                        React.createElement("th", null, t('EQUIPMENT_CLASS')),
                        React.createElement("th", null,
                            titleize(t('AVAILABLE', { count: 1 })),
                            "?"),
                        React.createElement("th", null,
                            titleize(t('AUTHORIZED')),
                            "?"),
                        React.createElement("th", null,
                            t('MULTIPLE_PICKUPS'),
                            "?"),
                        React.createElement("th", null,
                            t('RECEIVE_OFFERS'),
                            "?"))),
                React.createElement("tbody", null, this.renderDrivers())),
            this.state.drivers && this.state.drivers.length > 0 && (React.createElement("div", { className: "py-2 italic" }, t('SHOWING_DRIVERS_LENGTH', {
                drivers_length: this.state.drivers.length,
            }))),
            React.createElement("div", null, [
                React.createElement(DriverJobsModal, Object.assign({}, this.state.jobModal, { key: "jobs-modal", onClose: this.handleCloseModal })),
                React.createElement(AddDriverModal, { key: "add-driver-modal", onHide: this.handleCloseAddDriverModal, onSave: this.handleAddDriver, formState: this.state.addDriverModal.formState, savingDriver: this.state.savingDriver }),
            ])));
    }
}
export default withTranslation()(DriverList);
